import { render, staticRenderFns } from "./SVGIcons.vue?vue&type=template&id=1c33b0e2&scoped=true&"
import script from "./SVGIcons.vue?vue&type=script&lang=js&"
export * from "./SVGIcons.vue?vue&type=script&lang=js&"
function injectStyles (context) {
  
  var style0 = require("./SVGIcons.vue?vue&type=style&index=0&id=1c33b0e2&scoped=true&lang=scss&")
if (style0.__inject__) style0.__inject__(context)

}

/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  "1c33b0e2",
  null
  ,true
)

export default component.exports